const outElectricTrendColumns = [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'deviceCode',
    key: 'deviceCode',
    width: 280
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 360
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model',
    width: 160
  },
  {
    zh: '平均温度(℃)',
    en: 'Average Temperature(℃)',
    dataIndex: 'avgTemperature',
    key: 'avgTemperature',
    tooltip: true
  },
  {
    zh: '平均压力(MPa)',
    en: 'Average Pressure(MPa)',
    dataIndex: 'avgPressure',
    key: 'avgPressure',
    tooltip: true
  },
  {
    zh: '平均频率(Hz)',
    en: 'Average Frequency(Hz)',
    dataIndex: 'avgFrequency',
    key: 'avgFrequency',
    tooltip: true
  },
  {
    zh: '平均电流(A)',
    en: 'Average Current(A)',
    dataIndex: 'avgElectric',
    key: 'avgElectric',
    tooltip: true
  },
  {
    zh: '额定电流(A)',
    en: 'Rated Current(A)',
    dataIndex: 'ratedElectric',
    key: 'ratedElectric',
    tooltip: true
  }
]

export default outElectricTrendColumns